import React from "react";
import { Badge } from "@/components/ui/badge";
export default function InfrastructureCta() {
  return <section id="infrastructurecta" className="bg-background py-24 md:py-32">
      <div className="container mx-auto px-4 md:px-6 flex flex-col items-center text-center max-w-4xl">
        

        <h2 className="font-default text-4xl md:text-5xl lg:text-6xl font-bold text-foreground mb-6 leading-tight">
          Powering Industrial, Commercial and Automation Excellence with ABCO South
        </h2>

        <p className="font-sans text-lg md:text-xl text-muted-foreground mb-10 max-w-2xl leading-relaxed">
          Elevate your operational footprint with our precision engineering and robust construction services. We deliver certified installations built for the demands of modern industry.
        </p>
      </div>
    </section>;
}